<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200">
      <div class="hxq_yzjk_mbx" style="padding-left: 0px">
        <a href="/" class="allResult">首页<span class="newspan">></span></a>帮助中心
      </div>
      <div class="demo-image__preview" style="width:100%;display: inline-block;">
        <!--左侧导航开始-->
        <div>
          <LeftNavs :leftNavis='15'/>
        </div>
        <!--左侧导航结束-->
        <div class="cght_htmainrights">
          <div class="loading-wrap">
            <div class="content-title-wrap">
              <div class="content-title">投诉与建议</div>
            </div>
            <div class="loading-box">
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content"><i class="el-icon-s-order"></i></div>
                  </div>
                  <div class="n_right_head">
                    <p>投诉与建议</p>
                  </div>
                </div>
                <div class="n_content feedback-wrap">
                  <div class="feedback-content">
                    <img class="feedback-img" src="../../assets/images/xj_img9.jpg" alt="投诉与建议">
                    <ul class="feedback-icon">
                      <li class="left-icon">
                        <i class="el-icon-phone-outline"></i>
                        <div class="icon-text">
                          <span>投诉电话</span>
                          <h3>400-040-7890</h3>
                        </div>
                      </li>
                      <!-- <li class="right-icon">
                        <i class="icon-background2 el-icon-message"></i>
                        <a href="mailto:123@qq.com" target="_blank">
                          <div class="icon-text">
                            <span>投诉邮箱</span>
                            <h3>123@qq.com</h3>
                          </div>
                        </a>
                      </li> -->
                    </ul>
                    <p class="apology-text">当您使用此页面功能时，我们先为未能使您高效的完成采购工作而诚挚致歉，您可以通过以上两种途径联</p>
                    <p class="apology-text">系我们，非常重视您的反馈，并将积极配合满足您的相关诉求。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import LeftNavs from '@/components/Help/Left_navs'

export default {
  name: 'Help',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeftNavs
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.cght_htmainrights .loading-wrap {
  margin-left: 252px;
  top: 0;
  left: 0;
  right: 0;
}
.loading-wrap .content-title-wrap {
  height: 42px;
  background: #f7f7f7;
}
.loading-wrap .content-title-wrap .content-title {
  float: left;
  width: auto;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #666;
  line-height: 42px;
  margin-left: 16px;
}
.loading-wrap .loading-box {
  background-size: 74px auto;
  border-left: 1px dashed #e8e8e8;
  margin-left: 43px;
  margin-top: 25px;
  margin-bottom: 40px;
  height: auto;
}
.n_right_line {
  padding-bottom: 40px;
}
.n_right_line .n_title_line {
  text-align: left;
  margin-left: -30px;
}
.n_right_line .n_title_line .icon-background {
  float: left;
  margin-left: 10px;
  margin-right: 11px;
  width: 40px;
  height: 40px;
  background-color: #436aa6;
  border-radius: 50%;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n_title_line .icon-background .icon-content {
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.n_right_line .n_title_line .n_right_head {
  display: inline-block;
  margin-left: 21px;
}
.n_right_line .n_title_line .n_right_head p {
  font-size: 18px;
  color: #333;
  line-height: 20px;
  margin-bottom: 6px;
}
.n_right_line .n_title_line .n_right_head span {
  display: inline;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.n_right_line .n_content {
  margin-top: 20px;
  margin-left: 45px;
  text-align: left;
}
.n_right_line .n_content img {
  width: 855px;
}
.feedback-wrap .feedback-content {
  margin-top: 50px;
  width: 710px;
}
.feedback-wrap .feedback-content .feedback-img {
  width: 710px;
}
.feedback-wrap .feedback-content .feedback-icon {
  width: 710px;
  height: 128px;
  position: relative;
}
.feedback-wrap .feedback-content .feedback-icon .left-icon {
  width: 200px;
  position: absolute;
  left: 260px;
  top: 30px;
}
.feedback-wrap .feedback-content .feedback-icon .left-icon i {
  width: 48px;
  font-size: 48px;
  float: left;
}
.feedback-wrap .feedback-content .feedback-icon .left-icon .icon-text {
  margin-left: 16px;
  float: left;
  text-align: left;
  color: #666;
  font-size: 14px;
  line-height: 24px;
}
.feedback-wrap .feedback-content .feedback-icon .right-icon {
  position: absolute;
  left: 350px;
  top: 30px;
}
.icon-background2 {
  margin-left: 0!important;
  width: 62px!important;
}
.n_right_line .n_content i {
  width: 855px;
}
.feedback-wrap .feedback-content .feedback-icon .right-icon i {
  width: 48px;
  font-size: 48px;
  float: left;
}
.feedback-wrap .feedback-content .feedback-icon .right-icon .icon-text {
  margin-left: 16px;
  float: left;
  text-align: left;
  color: #666;
  font-size: 14px;
  line-height: 24px;
}
.feedback-wrap .feedback-content .apology-text {
  text-align: left;
  color: #666;
  font-size: 14px;
  line-height: 24px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/help/complaint.vue